import { MenuItem } from "../header-menu/HeaderMenuTypes";
import CollectionsMenuItem from "./menu-items/CollectionsMenuItem";
import LinkMenuItem from "./menu-items/LinkMenuItem";
import PageMenuItem from "./menu-items/PageMenuIItem";

interface MenuItemProps {
  item: MenuItem;
  itemIndex: number;
}

export default function HeaderMenuItem({ item, itemIndex }: MenuItemProps) {
  switch (item.menuItemType) {
    case "collection":
      return <CollectionsMenuItem item={item} itemIndex={itemIndex} />;
    case "page":
      return <PageMenuItem item={item} itemIndex={itemIndex} />;
    case "link":
      return <LinkMenuItem item={item} itemIndex={itemIndex} />;
    default:
      throw new Error(`Unknown menu item type ${item}`);
  }
}
